import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SeoTags from "@/components/SeoTags";
import { CATALOG_FILTERS, getCatalogFilterPath } from "@/lib/routes";
import {
  getModelFamilyGuides,
  getModelFamilyGuidePath,
} from "@shared/modelFamilyGuides";
import { buildGuidesIndexSeo, getCategoryPageContent } from "@shared/seo";
import { Link } from "wouter";

export default function Guides() {
  const seoMetadata =
    typeof window === "undefined"
      ? buildGuidesIndexSeo()
      : buildGuidesIndexSeo(window.location.origin);

  const modelFamilyGuides = getModelFamilyGuides();

  return (
    <div
      className="min-h-screen flex flex-col bg-background"
      style={{ backgroundColor: "var(--background)" }}
    >
      <SeoTags metadata={seoMetadata} />
      <Navbar />

      <main className="container flex-1 py-6">
        <section className="overflow-hidden rounded-[1.3rem] border border-border bg-card px-5 py-5 md:px-6 md:py-6">
          <p className="text-[0.72rem] font-semibold uppercase tracking-[0.16em] text-primary">
            Market Value Guides
          </p>
          <h1 className="mt-3 text-[1.45rem] font-semibold tracking-[-0.04em] text-foreground md:text-[1.9rem]">
            Browse market value guides by category and device family
          </h1>
          <p className="mt-3 max-w-[52rem] text-sm leading-7 text-muted-foreground md:text-[0.98rem]">
            Category guides help people understand a whole market, while family
            guides focus on high-intent product groups like iPhone SE, PS5, and
            Nintendo Switch.
          </p>
        </section>

        <section className="mt-6">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-[1.2rem] font-semibold tracking-[-0.03em] text-foreground md:text-[1.45rem]">
                Category market value guides
              </h2>
              <p className="mt-2 text-sm leading-7 text-muted-foreground">
                Every category guide is a public page people can browse, share,
                and find in search.
              </p>
            </div>
          </div>

          <div className="mt-4 grid gap-3 md:grid-cols-2 xl:grid-cols-3">
            {CATALOG_FILTERS.map(filter => {
              const content = getCategoryPageContent(filter.slug, filter.label);

              return (
                <Link
                  key={filter.slug}
                  href={getCatalogFilterPath(filter.slug)}
                  className="rounded-[1.15rem] border border-border bg-card px-5 py-5 transition-colors hover:border-primary/35 hover:bg-primary/5"
                >
                  <p className="text-[0.72rem] font-semibold uppercase tracking-[0.16em] text-primary">
                    Market Value Guide
                  </p>
                  <h3 className="mt-3 text-lg font-semibold text-foreground">
                    {content.titlePlain}
                  </h3>
                  <p className="mt-2 text-sm leading-7 text-muted-foreground">
                    {content.intro}
                  </p>
                </Link>
              );
            })}
          </div>
        </section>

        <section className="mt-6">
          <div>
            <h2 className="text-[1.2rem] font-semibold tracking-[-0.03em] text-foreground md:text-[1.45rem]">
              Device family guides
            </h2>
            <p className="mt-2 text-sm leading-7 text-muted-foreground">
              These are more specific landing pages for recurring search-intent
              clusters like iPhone 6, iPhone SE, PS5, and iPad Pro.
            </p>
          </div>

          <div className="mt-4 grid gap-3 md:grid-cols-2 xl:grid-cols-3">
            {modelFamilyGuides.map(guide => (
              <Link
                key={guide.slug}
                href={getModelFamilyGuidePath(guide.slug)}
                className="rounded-[1.15rem] border border-border bg-card px-5 py-5 transition-colors hover:border-primary/35 hover:bg-primary/5"
              >
                <p className="text-[0.72rem] font-semibold uppercase tracking-[0.16em] text-primary">
                  Family Guide
                </p>
                <h3 className="mt-3 text-lg font-semibold text-foreground">
                  {guide.shortLabel}
                </h3>
                <p className="mt-2 text-sm leading-7 text-muted-foreground">
                  {guide.intro}
                </p>
              </Link>
            ))}
          </div>
        </section>
      </main>

      <div className="mt-auto">
        <Footer />
      </div>
    </div>
  );
}
